module.exports = __webpack_public_path__ + "img/TSGModulLadestation.7f211416.png";